import BN from "bignumber.js";

export const removeTrailingZeroes = (input = "") => {
  let output = input;
  if (input.indexOf(".") > -1 && input.endsWith("0")) {
    output = input.replace(/0*$/, "").replace(/\.$/, "");
  }
  return output;
};

const numeralFilter = (
  value,
  format = "0,0.00",
  removeZeroes = true,
  roundHalfCeil = true
) => {
  const decimalPlaces = format.split(".")[1]?.length ?? 0;
  let output = new BN(value).toFormat(
    decimalPlaces,
    roundHalfCeil ? BN.ROUND_HALF_CEIL : BN.ROUND_DOWN
  );
  output = output !== "NaN" ? output : new BN(0).toFormat(decimalPlaces);
  output = removeZeroes ? removeTrailingZeroes(output) : output;
  return output;
};

export default numeralFilter;
